import PropTypes from "prop-types";

import { alignItems } from "../../../../../consts";
import { t } from "../../../../../services";
import {
  FlexContainers,
  GradientLoader,
  IconButton,
  SVG,
  WrapperContainer
} from "../../../../../components";
import { CardWrapper, IconContainer, Info, Title } from "./styled";

export const UserStatisticsCardTemplate = ({
  title,
  stats,
  icon,
  iconBackground,
  loading,
  children,
  onExpand
}) => {
  return (
    <CardWrapper
      Container={FlexContainers.FlexColumnBetween}
      alignItems={alignItems.start}
      gap={8}
      width={"100%"}>
      <WrapperContainer
        Container={FlexContainers.FlexColumnStart}
        alignItems={alignItems.start}
        gap={4}
        width={"100%"}>
        <WrapperContainer Container={FlexContainers.FlexRowBetween} gap={8} width={"100%"}>
          <WrapperContainer Container={FlexContainers.FlexRowStart} gap={8}>
            <IconContainer
              Container={FlexContainers.FlexColumnCenter}
              iconBackground={iconBackground}>
              {icon}
            </IconContainer>
            <Title>{t(title)}</Title>
          </WrapperContainer>

          {onExpand && (
            <IconButton onClick={onExpand}>
              <SVG.ArrowRightRoundedIcon />
            </IconButton>
          )}
        </WrapperContainer>

        {loading ? (
          <WrapperContainer Container={FlexContainers.FlexColumnCenter} height={32}>
            <GradientLoader width={54} height={21} />
          </WrapperContainer>
        ) : (
          <Info> {stats}</Info>
        )}
      </WrapperContainer>

      {children}
    </CardWrapper>
  );
};

UserStatisticsCardTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  stats: PropTypes.oneOfType([PropTypes.number, PropTypes.node]).isRequired,
  icon: PropTypes.node.isRequired,
  iconBackground: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  children: PropTypes.node.isRequired,
  onExpand: PropTypes.func
};
